import { Component, isDevMode, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrapiSyncContextService } from './brapi-sync-context.service';
import { BrapiSyncPath, BrapiSyncService } from './brapi-sync.service';
import { SubscriptionsManager } from '../shared/util/subscriptions-manager';


@Component({
    selector: 'app-brapi-sync',
    templateUrl: './brapi-sync.component.html',
    styleUrls: ['./brapi-sync.component.css']
})
export class BrapiSyncComponent implements OnInit, OnDestroy {

    title = 'brapi-sync-angular';
    subscriptionManager = new SubscriptionsManager();

    constructor(private route: ActivatedRoute,
                private context: BrapiSyncContextService,
                private brapiSyncService: BrapiSyncService) { }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    ngOnInit(): void {
        this.context.isEmbedded = !isDevMode();
        this.brapiSyncService.navigateToPageAndReloadTo(BrapiSyncPath.Connections);

        this.subscriptionManager.add = this.route.params.subscribe(async params => {
            this.brapiSyncService.navigateToPageAndReloadTo(BrapiSyncPath.Connections);
        });

    }

}
